import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild,
  OnDestroy,
  OnInit,
  inject
} from '@angular/core';
import { selectorCoreFormCurrentPageStatus } from '@bepatient/core';
import { IonInput, IonItem } from '@ionic/angular';
import { Store } from '@ngrx/store';
import chroma from 'chroma-js';
import { Subscription } from 'rxjs';
import { SocialSecurityQuestionV3 } from '../../../classes/question-social-security';
import { QuestionBaseV3ComponentDirective } from '../question-base.component';

@Component({
  selector: 'bepatient-input-social-security-v3',
  templateUrl: './input-social-security.component.html',
  styleUrls: ['./input-social-security.component.scss'],
  standalone: false
})
export class InputSocialSecurityComponentV3
  extends QuestionBaseV3ComponentDirective
  implements OnInit, AfterViewInit, OnDestroy
{
  private store$ = inject<Store<any>>(Store);

  @Input() question: SocialSecurityQuestionV3;
  @Input() color: string;

  isBlur = true;
  hasError: boolean;
  subscription: Subscription;
  maxLength = 18;
  dirty: boolean;

  @ViewChild(IonItem, { read: ElementRef, static: true })
  private ionItem: ElementRef;

  @ViewChild(IonInput, { read: ElementRef, static: true })
  private ionInput: ElementRef;

  get value() {
    return this.formGroup.get(this.question.key).value;
  }

  ngOnInit(): void {
    this.maxLength = this.question.useKey ? 21 : this.maxLength;
  }

  ngAfterViewInit(): void {
    // this.checkFieldError();
    this.ionItem.nativeElement.style.setProperty(
      '--input-valid-background',
      chroma(this.color).alpha(0.1).css()
    );
  }

  ngDoCheck(): void {
    this.dirty = this.formGroup.get(this.question.key).dirty;
  }

  onBlur(): void {
    this.isBlur = true;
    this.formGroup.get(this.question.key).markAsDirty();
  }

  onFocus(): void {
    this.isBlur = false;
  }

  onChange(evt: any): void {
    this.isBlur = false;
    this.formGroup.get(this.question.key).markAsTouched();
    this.dirty = this.formGroup.get(this.question.key).dirty;

    const value = evt.detail.value;
    if (value) {
      this.ionInput.nativeElement.value = this.parseToSS(value);
    }

    // this.checkFieldError();
  }

  isEmpty(): boolean {
    return !this.ionInput.nativeElement.value;
  }

  /**
   * Check control errors and set the field background
   */
  // checkFieldError(): void {
  //   let controlErrors = this.formGroup.get(this.question.key).errors;
  //   this.hasError = controlErrors && (this.value || this.dirty) ? true : false;
  //   this.itemBackgroundColor();
  // }

  // itemBackgroundColor(): void {
  //   if (this.hasError) {
  //     this.ionItem.nativeElement.style.setProperty(
  //       '--background',
  //       'rgba(var(--ion-color-danger-rgb), 0.1)'
  //     );
  //   } else {
  //     if (!this.isEmpty()) {
  //       this.ionItem.nativeElement.style.setProperty(
  //         '--background',
  //         chroma(this.color).alpha(0.1).css()
  //       );
  //     } else {
  //       this.ionItem.nativeElement.style.setProperty(
  //         '--background',
  //         'var(--ion-color-light)'
  //       );
  //     }
  //   }
  // }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    // this.subscription.unsubscribe();
  }

  private parseToSS(input: string): string {
    const separatorPosition = this.question.useKey
      ? [1, 4, 7, 10, 14, 18]
      : [1, 4, 7, 10, 14];
    const arrayFromString = input.split('').filter(v => v !== ' ');
    separatorPosition.forEach(value => {
      if (value < arrayFromString.length) {
        arrayFromString.splice(value, 0, ' ');
      }
    });

    return arrayFromString.join('');
  }
}
